// StatRow (drawing v2.6, `stats()`; standard rule 3): three or four big
// numbers in one card, counted by the server, never inside a sentence, with a
// filter line on top that says which filters and scope they count. On a phone
// the row folds to one line ("Follows your 3 filters") and a tap opens the
// figures two by two.

import { useState, type ReactNode } from "react";
import { ChevronDown, Filter } from "lucide-react";
import { cx } from "./cx";

export interface Stat {
  label: ReactNode;
  value: ReactNode;
  unit?: ReactNode;
  meta?: ReactNode;
  metaTone?: "warn" | "good";
}

export function StatRow({ stats, filterLine, filterShort, className }: { stats: Stat[]; /** "These numbers follow your filters: <b>…</b>" */ filterLine?: ReactNode; /** The one-line phone form: "Follows your 3 filters". */ filterShort?: ReactNode; className?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <section className={cx("pg-card pg-nums", open && "is-open", className)} aria-label="Numbers">
      {filterLine && (
        <div className="pg-filt">
          <Filter className="pg-ico pg-ico--s" aria-hidden />
          <span className="pg-filt__t">{filterLine}</span>
          <button type="button" className="pg-filt__s" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
            {filterShort ?? filterLine}
            <ChevronDown className="pg-ico pg-ico--s" aria-hidden />
          </button>
        </div>
      )}
      <div className="pg-stats">
        {stats.map((s, i) => (
          <div className="pg-stat" key={i}>
            <div className="pg-stat__k">{s.label}</div>
            <div className="pg-stat__v">
              {s.value}
              {s.unit && <small>{s.unit}</small>}
            </div>
            {s.meta && <div className={cx("pg-stat__m", s.metaTone === "warn" && "pg-stat__m--w", s.metaTone === "good" && "pg-stat__m--g")}>{s.meta}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
